import React from 'react';
import { Twitter, Github, Mail } from 'lucide-react';
import ThemeAwareFullLogo from '@/shared/components/ThemeAwareFullLogo';
import { VersionInfo } from '@/shared/components/VersionInfo';

export const LandingFooter: React.FC = () => {
  return (
    <footer className="py-12 bg-neutral-50 dark:bg-neutral-900 border-t-2 border-neutral-950 dark:border-neutral-100">
      <div className="px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-4">
          <div className="border border-neutral-950 dark:border-neutral-100 p-2 bg-background">
             <ThemeAwareFullLogo className="h-6 w-auto opacity-100 grayscale" />
          </div>
          <span className="text-sm font-mono text-muted-foreground">© 2025 Codii.dev</span>
        </div>

        <div className="flex gap-0 border border-neutral-950 dark:border-neutral-100 bg-background">
           <a href="https://github.com/codii-dev" className="p-3 border-r border-neutral-950 dark:border-neutral-100 text-muted-foreground hover:text-foreground hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors">
              <Github className="w-5 h-5" />
           </a>
           <a href="https://x.com/codii_dev" className="p-3 border-r border-neutral-950 dark:border-neutral-100 text-muted-foreground hover:text-foreground hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors">
              <Twitter className="w-5 h-5" />
           </a>
           <a href="mailto:hello@codii.dev" className="p-3 text-muted-foreground hover:text-foreground hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors">
              <Mail className="w-5 h-5" />
           </a>
        </div>

        <div className="text-xs text-muted-foreground font-mono">
          <VersionInfo />
        </div>
      </div>
    </footer>
  );
};
